const blockVideo = () => {
  $('.play-btn').on('click', () => {
    // +++ Create functions that post either play or pause +++
    // Match the protocol of the of the parent's page
    const theProtocol = location.protocol;
    const theURL = theProtocol + '//players.brightcove.net';
      // Retrieve window object needed for postMessage
    const win = document.querySelector('iframe').contentWindow;
    // Post message passing 'playVideo' as the data
    if(win) {
      win.postMessage('playVideo', theURL);
      $('.poster').toggleClass('play');
    }
  });
};

export default blockVideo;
